// Libraries
import moment from 'moment'
import React from 'react'

// Styles
import { RelatedCustomerStoriesContainer } from './style'

// Components
import Button from '../button'
import GlobalContainer from '../globalContainer'
import Typography from '../typography'

// Helpers
import ImgUtil from '../../../utils/img.utils'
import { getMicrocopyData } from '../../../utils/microcopy.utils'
import WrapperImage from '../wrapperImage'

const RelatedCustomerStories = (props: any) => {
  if (props.data) {
    const stories = props.data
    const customerStoryMicrocopy = props.data.length && props.data[0].customerStoryMicrocopy?.values
    let sectionTitle: string = ''
    if (customerStoryMicrocopy) {
      let relatedTextSet = customerStoryMicrocopy.filter(
        (item: any) => item.key?.includes('stories') && item.key?.includes('relatedText')
      )
      sectionTitle = relatedTextSet && relatedTextSet[0] && relatedTextSet[0].value
    }

    const generateCard = (item: any, index: number) => {
      let mainImg = item.mainImage?.image?.file?.url
      let mainImgAlt = item.mainImage?.altText
      let resourceCategory = item.resourceCategory?.title
      let categoryNumber = item.resourceCategory?.number
      let microcopy = item.microcopy
      let body = item.teaserBody ? item.teaserBody : item.h1Title
      let ctaLink = `/${item.slug}`
      let date = item.date
      let regularIcon: boolean = false

      if (date) {
        date = new Date(date)
        date = moment(date).format('D MMM YYYY')
      }

      let cta =
        microcopy &&
        categoryNumber &&
        getMicrocopyData(microcopy, categoryNumber, 'primary', 'text')

      let title: string = ''
      let whiteLogo: string = ''
      let whiteLogoAltText: string = ''

      if (item.metaInformation && item.metaInformation.length) {
        for (let i = 0; i < item.metaInformation.length; i++) {
          if (item.metaInformation[i].__typename === 'ContentfulTopicCustomerDetails') {
            let customerDetail = item.metaInformation[i]
            title = customerDetail.customerName
            whiteLogoAltText = customerDetail.whiteLogo?.altText
            whiteLogo = customerDetail.whiteLogo?.image?.file?.url
            break
          }
        }
      }
      if (!whiteLogo) {
        whiteLogo = item.resourceCategory?.whiteImage?.image?.file?.url
        regularIcon = true
        whiteLogoAltText = item.resourceCategory?.whiteImage?.altText
      }

      return (
        <div className="RelatedCustomerStories__Item">
          <a key={`RelatedCustomerStories-${index}`} href={ctaLink}>
            <div className="RelatedCustomerStories__Image-Container">
              {mainImg && (
                <WrapperImage
                  className="RelatedCustomerStories__BackgroundImg"
                  alt={mainImgAlt}
                  src={ImgUtil.getResizedImageUrl(mainImg, '')}
                  threshold={650}
                />
              )}
              {whiteLogo && (
                <WrapperImage
                  className={`RelatedCustomerStories__WhiteLogo ${
                    regularIcon ? 'RelatedCustomerStories__default_logo' : ''
                  }`}
                  alt={whiteLogoAltText}
                  src={ImgUtil.getResizedImageUrl(whiteLogo, '')}
                  threshold={650}
                />
              )}
            </div>
            <div className="RelatedCustomerStories__Text-Container">
              {resourceCategory && (
                <Typography className="RelatedCustomerStories__Category" type="captionAlt">
                  {resourceCategory}
                </Typography>
              )}
              {title && <Typography type="header6">{title}</Typography>}
              {body && (
                <Typography className="RelatedCustomerStories__Body" type="bodyXSWrapper">
                  {body}
                </Typography>
              )}
              {ctaLink && cta && cta[0] && cta[0].value && (
                <Button
                  icon={true}
                  href={ctaLink}
                  text={cta[0].value}
                  type="text-link"
                  size="small"
                  theme={'light'}
                />
              )}
            </div>
          </a>
        </div>
      )
    }

    return (
      <RelatedCustomerStoriesContainer data-cy="RelatedCustomerStories">
        {sectionTitle && <Typography type="header2">{sectionTitle}</Typography>}
        <GlobalContainer className="RelatedCustomerStories">
          {stories && stories.map((story: any, idx: number) => generateCard(story, idx))}
        </GlobalContainer>
      </RelatedCustomerStoriesContainer>
    )
  }

  return null
}

export default RelatedCustomerStories
